import { authUtils } from "../modules/auth/utils/auth.utils";

/**
 * Interface for HR navigation configuration
 */
interface HRNavigationConfig {
  hrUrl?: string;
  hrAuthRoute?: string;
  openInNewTab?: boolean;
}

/**
 * Handles navigation to the external HR module with authentication tokens
 * @param config Optional configuration for HR navigation
 * @returns Promise<boolean> - Returns true if navigation was successful, false otherwise
 */
export const navigateToHRModule = async (
  config: HRNavigationConfig = {}
): Promise<boolean> => {
  try {
    // Get authentication tokens
    const accessToken = authUtils.getAccessToken();
    const refreshToken = authUtils.getRefreshToken();

    if (!accessToken || !refreshToken) {
      console.error("No authentication tokens found for HR module navigation");
      return false;
    }

    // Use provided config or fall back to environment variables
    const hrUrl =
      config.hrUrl || process.env.REACT_APP_HR_URL || "http://localhost:5173";

    const hrAuthRoute =
      config.hrAuthRoute ||
      process.env.REACT_APP_HR_AUTH_ROUTE ||
      "/auth/callback";

    // Construct the full URL with tokens
    const hrNavigationUrl = `${hrUrl}${hrAuthRoute}?accessToken=${encodeURIComponent(
      accessToken
    )}&refreshToken=${encodeURIComponent(refreshToken)}`;

    // Navigate based on configuration
    if (config.openInNewTab) {
      // Open in new tab
      const newWindow = window.open(hrNavigationUrl, "_blank");
      if (!newWindow) {
        console.error(
          "Failed to open HR module in new tab. Popup might be blocked."
        );
        return false;
      }
    } else {
      // Navigate in same window
      window.location.href = hrNavigationUrl;
    }

    return true;
  } catch (error) {
    console.error("Error navigating to HR module:", error);
    return false;
  }
};